import React from 'react'
import './playerlist.css'
import HorizontalPlayerCard from './HorizontalPlayerCard';
import Fab from '@mui/material/Fab';
const MyPlayerList = (props) => {
    const myPlayerList=props.playerList;
    function handleClose() {
        if(props.close){
            props.close();
        }
    }
    
    return (
        <>
        <div className="vertical-align-container">
            <h1 style={{textAlign:"center", color:"white"}}>Your Players</h1>
            {myPlayerList.map((player)=>{
                return <div style={{color:"white"}}>
                    <HorizontalPlayerCard player={player}/>
                    </div>
            })
            }
        </div>
        <div style={{display:(props.isMobile?"auto":"none")}} class="fixed-centre-modal-close"><Fab onClick={props.close} variant="extended" color="secondary"><div style={{fontSize:"21px"}}>× Close</div></Fab> </div>
       </>
    )
}

export default MyPlayerList
